(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('findStock', {
        templateUrl: 'views/components/views/findStock/findStock.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['stateService', 'utilityService', 'findStockService', 'logisticService', 'rememberService', 'layoutService', function (stateService, utilityService, findStockService, logisticService, rememberService, layoutService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            
            let variableNames = {
                barcode: '',
                businessco_no: '',
                stockplace_id: ''
            };

            vm.model = {
                tabletSize: layoutService.getMediaQueries().tablet,
                bgFindStockDisplay: {
                    selected: 'COUNTING',
                    buttons: [
                        { id: 'COUNTING', label: 'bg_findstockdisplay_counting', color: 'primary', onClick: () => vm.model.bgFindStockDisplay.selected = 'COUNTING' },
                        { id: 'OTHER', label: 'bg_findstockdisplay_other', color: 'primary', onClick: () => vm.model.bgFindStockDisplay.selected = 'OTHER' }
                    ]
                },
                stockValueButtons: [
                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('stockget', { stock_keyno: vm.model.scanResponse.stock_keyno }) }
                ],
                exAssignedButtons: [
                    {
                        id: 'goto',
                        icon: 'fa fa-solid fa-chevron-right',
                        color: 'primary',
                        type: 'primary',
                        onClick: () => stateService.go('stockcorrection', {
                            stock_keyno: vm.model.scanResponse.stock_keyno,
                            stocklocation_keyno: vm.model.scanResponse.stocklocation_keyno
                        })
                    }
                ],
                stockIncomingButtons: [
                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('stockincoming', { stock_keyno: vm.model.scanResponse.stock_keyno }) }
                ],
                stockOutgoingButtons: [
                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('stockoutgoing', { stock_keyno: vm.model.scanResponse.stock_keyno }) }
                ],
                eanListButtons: [
                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('producteans', { prod_id: vm.model.scanResponse.prod_id }) }
                ],
                setting: {},
                scanningResponse: {},
                selectListCompanies: [],
                selectListStockPlaces: [],
                scanning: false,
                lockedConfirm: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadSetting() {
                vm.model.setting = (await findStockService.getSetting())[0];

                return Promise.all([
                    loadStockPlaces()
                ]).then(() => {
                    retrieveScanResponse('setting');

                    Promise.resolve();
                });
            }
            
            async function loadCompanies() {
                vm.model.selectListCompanies = await logisticService.listCompanies();
            }
            
            async function loadStockPlaces() {
                if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;
                
                return vm.model.selectListStockPlaces = await logisticService.listStocks({ businessco_no: vm.model.setting.businessco_no });
            }

            async function retrieveScanResponse(id) {
                switch (id) {
                    case 'setting':
                        if (utilityService.validateParmsValue(vm.model.setting.barcode) !== true) return;
                        if (utilityService.validateParmsValue(vm.model.setting.stockplace_id, true) !== true) return;

                        vm.model.scanResponse = (await findStockService.scanStock({
                            barcode: vm.model.setting.barcode,
                            stockplace_id: vm.model.setting.stockplace_id
                        }))[0];
                        break;
                    case 'barcode':
                        if (utilityService.validateParmsValue(vm.model.setting.barcode) !== true) return;
                        if (utilityService.validateParmsValue(vm.model.setting.stockplace_id, true) !== true) return;

                        vm.model.scanResponse = (await findStockService.scanStock({
                            barcode: vm.model.setting.barcode,
                            stockplace_id: vm.model.setting.stockplace_id
                        }))[0];

                        vm.model.scanning = false;

                        clear('barcode');

                        if (vm.model.scanResponse.gotowebpage === '1') stateService.go(vm.model.scanResponse.webpagename, vm.model.scanResponse.parms);
                        break;
                    case 'stockplace_id':
                        if (utilityService.validateParmsValue(vm.model.setting.barcode) !== true) return;
                        if (utilityService.validateParmsValue(vm.model.setting.stockplace_id, true) !== true) return;

                        vm.model.scanResponse = (await findStockService.scanStock({
                            barcode: vm.model.setting.barcode,
                            stockplace_id: vm.model.setting.stockplace_id
                        }))[0];

                        if (vm.model.scanResponse.gotowebpage === '1') stateService.go(vm.model.scanResponse.webpagename, vm.model.scanResponse.parms);
                        break;
                    default:
                        break;
                }
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            function rememberFunc(id) {
                Object.keys(variableNames).forEach((key) => {
                    switch (key) {
                        case 'barcode':
                    	case 'businessco_no':
                        case 'stockplace_id':
                    		variableNames[key] = stateService.getCurrentName() + '.' + key;
                    		break;
                    	default:
                    		variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
                    		break;
                    }
                });

                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

                let variableValue = null;

                switch (id) {
                    case 'barcode':
                    case 'businessco_no':
                    case 'stockplace_id':
                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

                        variableValue = vm.model.setting[id];
                        break;
                    default:
                        break;
                }

                return rememberService.remember(variableNames[id], variableValue);
            }

            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            // #region CLEAR BUTTON FUNCTION

            function clear(id) {
                switch (id) {
                    case 'barcode':
                        vm.model.setting.barcode = '';
                        break;
                    default:
                        break;
                }
            }

            // #endregion CLEAR BUTTON FUNCTION

            // #region SCAN FUNCTION

            vm.scanValues = function () {
                vm.model.scanning = true;
                rememberFunc('barcode');
                retrieveScanResponse('barcode');
            };

            // #endregion SCAN FUNCTION

            // #region BUTTON GROUP SINGLE FUNCTION

            vm.selectBgFindStockDisplay = function (value) {
                vm.model.bgFindStockDisplay.selected = value;
            };

            // #endregion BUTTON GROUP SINGLE FUNCTION

            // #region CONFIRM FUNCTION

            vm.confirmValues = function () {
                vm.model.lockedConfirm = true;

                findStockService.confirmStockValue(vm.model.scanResponse).then(function () {
                    vm.model.lockedConfirm = false;
                }, function () {
                    vm.model.lockedConfirm = false;
                });
            };

            // #endregion CONFIRM FUNCTION

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.onChanged = function (value, id) {
                switch (id) {
                    case 'businessco_no':
                        if (utilityService.validateWatchValue(value, vm.model.setting.businessco_no) !== true) return;

                        vm.model.setting.businessco_no = value;

                        if (utilityService.validateParmsValue(vm.model.setting.businessco_no) !== true) return;

                        rememberFunc('businessco_no');
                        loadStockPlaces();
                        break;
                    case 'stockplace_id':
                        if (utilityService.validateWatchValue(value, vm.model.setting.stockplace_id) !== true) return;

                        vm.model.setting.stockplace_id = value;

                        if (utilityService.validateParmsValue(vm.model.setting.stockplace_id) !== true) return;

                        rememberFunc('stockplace_id');
                        retrieveScanResponse('stockplace_id');
                        break;
                    default:
                        utilityService.setValueToVariable(value);
                        break;
                }
            };

            // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                loadSetting();
                loadCompanies();
            };

            // #endregion ON INIT FUNCTION

        }]
    });
})();
